var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgApiDocs = function SvgApiDocs(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5.15674,
    width: 17,
    height: 21,
    rx: 3,
    fill: "#AE990C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9931 14.2617L28.3525 11.9145C27.8033 11.4264 27.0941 11.1567 26.3594 11.1567H18C16.3431 11.1567 15 12.4999 15 14.1567V29.1567C15 30.8136 16.3431 32.1567 18 32.1567H29C30.6569 32.1567 32 30.8136 32 29.1567V16.5039C32 15.647 31.6336 14.831 30.9931 14.2617Z",
    fill: "#FCE449"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.459 14.6567V11.6224C27.459 11.2661 27.8898 11.0876 28.1418 11.3396L31.7761 14.9739C32.0281 15.2259 31.8497 15.6567 31.4933 15.6567H28.459C27.9067 15.6567 27.459 15.209 27.459 14.6567Z",
    fill: "#AE990C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.5H24",
    stroke: "#FCF6D1",
    strokeDasharray: "1 1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.1567H13",
    stroke: "#FCF6D1",
    strokeDasharray: "1 1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16.1567H26",
    stroke: "#FCF6D1",
    strokeDasharray: "1 1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 20.1567H19",
    stroke: "#FCF6D1",
    strokeDasharray: "1 1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6 24.1567H17",
    stroke: "#FCF6D1",
    strokeDasharray: "1 1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 30.1567,
    r: 3,
    stroke: "#FCF6D1",
    strokeDasharray: "1 1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 6.15674,
    r: 3,
    stroke: "#FCF6D1",
    strokeDasharray: "1 1"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgApiDocs);
var Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzUiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNSAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMyIgeT0iNS4xNTY3NCIgd2lkdGg9IjE3IiBoZWlnaHQ9IjIxIiByeD0iMyIgZmlsbD0iI0FFOTkwQyIvPgo8cGF0aCBkPSJNMzAuOTkzMSAxNC4yNjE3TDI4LjM1MjUgMTEuOTE0NUMyNy44MDMzIDExLjQyNjQgMjcuMDk0MSAxMS4xNTY3IDI2LjM1OTQgMTEuMTU2N0gxOEMxNi4zNDMxIDExLjE1NjcgMTUgMTIuNDk5OSAxNSAxNC4xNTY3VjI5LjE1NjdDMTUgMzAuODEzNiAxNi4zNDMxIDMyLjE1NjcgMTggMzIuMTU2N0gyOUMzMC42NTY5IDMyLjE1NjcgMzIgMzAuODEzNiAzMiAyOS4xNTY3VjE2LjUwMzlDMzIgMTUuNjQ3IDMxLjYzMzYgMTQuODMxIDMwLjk5MzEgMTQuMjYxN1oiIGZpbGw9IiNGQ0U0NDkiLz4KPHBhdGggZD0iTTI3LjQ1OSAxNC42NTY3VjExLjYyMjRDMjcuNDU5IDExLjI2NjEgMjcuODg5OCAxMS4wODc2IDI4LjE0MTggMTEuMzM5NkwzMS43NzYxIDE0Ljk3MzlDMzIuMDI4MSAxNS4yMjU5IDMxLjg0OTcgMTUuNjU2NyAzMS40OTMzIDE1LjY1NjdIMjguNDU5QzI3LjkwNjcgMTUuNjU2NyAyNy40NTkgMTUuMjA5IDI3LjQ1OSAxNC42NTY3WiIgZmlsbD0iI0FFOTkwQyIvPgo8cGF0aCBkPSJNNiA4LjVIMjQiIHN0cm9rZT0iI0ZDRjZEMSIgc3Ryb2tlLWRhc2hhcnJheT0iMSAxIi8+CjxwYXRoIGQ9Ik02IDEyLjE1NjdIMTMiIHN0cm9rZT0iI0ZDRjZEMSIgc3Ryb2tlLWRhc2hhcnJheT0iMSAxIi8+CjxwYXRoIGQ9Ik02IDE2LjE1NjdIMjYiIHN0cm9rZT0iI0ZDRjZEMSIgc3Ryb2tlLWRhc2hhcnJheT0iMSAxIi8+CjxwYXRoIGQ9Ik02IDIwLjE1NjdIMTkiIHN0cm9rZT0iI0ZDRjZEMSIgc3Ryb2tlLWRhc2hhcnJheT0iMSAxIi8+CjxwYXRoIGQ9Ik02IDI0LjE1NjdIMTciIHN0cm9rZT0iI0ZDRjZEMSIgc3Ryb2tlLWRhc2hhcnJheT0iMSAxIi8+CjxjaXJjbGUgY3g9IjYiIGN5PSIzMC4xNTY3IiByPSIzIiBzdHJva2U9IiNGQ0Y2RDEiIHN0cm9rZS1kYXNoYXJyYXk9IjEgMSIvPgo8Y2lyY2xlIGN4PSIyOSIgY3k9IjYuMTU2NzQiIHI9IjMiIHN0cm9rZT0iI0ZDRjZEMSIgc3Ryb2tlLWRhc2hhcnJheT0iMSAxIi8+Cjwvc3ZnPgo=";